(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initSection = (section) => {
    if (!section) return;

    if (typeof section._ncProgressCleanup === 'function') {
      section._ncProgressCleanup();
    }

    const carousel = section.querySelector('ul[id^="Slider-"]');
    const track = section.querySelector('[data-nc-progress]');
    const bar = section.querySelector('[data-nc-progress-bar]');
    if (!carousel || !track || !bar) return;

    let frame = 0;
    const update = () => {
      frame = 0;
      const totalWidth = carousel.scrollWidth;
      const visibleWidth = carousel.clientWidth;
      const trackWidth = track.clientWidth;
      if (!totalWidth || !visibleWidth || !trackWidth) return;

      const maxScroll = Math.max(totalWidth - visibleWidth, 0);
      const barWidth = maxScroll > 0
        ? Math.min(trackWidth, Math.max(24, trackWidth * visibleWidth / totalWidth))
        : trackWidth;
      const currentScroll = Math.min(maxScroll, Math.max(0, Math.abs(carousel.scrollLeft)));
      const progress = maxScroll > 0 ? currentScroll / maxScroll : 0;
      const position = progress * Math.max(trackWidth - barWidth, 0);

      bar.style.width = `${barWidth}px`;
      bar.style.transform = `translate3d(${position}px, 0, 0)`;
    };

    const requestUpdate = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };

    carousel.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(requestUpdate) : null;
    resizeObserver?.observe(carousel);
    resizeObserver?.observe(track);

    const mutationObserver = 'MutationObserver' in window ? new MutationObserver(requestUpdate) : null;
    mutationObserver?.observe(carousel, { childList: true, subtree: true });

    section.querySelectorAll('img').forEach((image) => {
      if (!image.complete) image.addEventListener('load', requestUpdate, { once: true });
    });

    section._ncProgressCleanup = () => {
      if (frame) cancelAnimationFrame(frame);
      carousel.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);
      resizeObserver?.disconnect();
      mutationObserver?.disconnect();
    };

    requestUpdate();
    setTimeout(requestUpdate, 250);
    setTimeout(requestUpdate, 1000);
  };

  const initAll = (scope = document) => {
    const sections = new Set();
    if (scope.matches?.('[data-nc-progress]')) {
      sections.add(scope.closest('[id^="shopify-section-"]'));
    }
    scope.querySelectorAll?.('[data-nc-progress]').forEach((track) => {
      sections.add(track.closest('[id^="shopify-section-"]'));
    });
    sections.forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
